/* @flow */
import { isNumber } from 'lodash';
import * as React from 'react';

import './styles/AdminStatisticsChartTooltip.scss';

type Props = {
  children?: React.Node,
  title: string,
};

export default function AdminStatisticsChartTooltip({ children, title }: Props) {
  return (
    <div className="AdminStatisticsChartTooltip">
      {// when not showing axis, the `title` is just an index & not the date
      !isNumber(title) && <header className="AdminStatisticsChartTooltip-header">{title}</header>}
      <div className="AdminStatisticsChartTooltip-body">{children}</div>
    </div>
  );
}
